import React from "react";
import { Link } from "react-router-dom";

export default function TemplateRow({ item, displayNo }) {
  return (
    <div className="others-template-row">
      <div className="others-template-col-no">{displayNo}</div>

      <div className="others-template-col-title">
        <Link
          to={`/documents/others/${item.id}`}
          className="others-template-title-link"
        >
          {item.title}
        </Link>
      </div>

      <div className="others-template-col-writer">{item.writer}</div>
      <div className="others-template-col-date">{item.date}</div>
      <div className="others-template-col-view">{item.view}</div>
    </div>
  );
}